import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Coins, Boxes, Check, Loader2, Palette } from "lucide-react";
import { spaceApi } from "./spaceApi";
import { SpaceHomeBtn } from "./SpaceNav";

export default function SkinStore({ onBack }) {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => spaceApi.skinsGet().then(setData).catch(() => toast.error("Could not load store"));
  useEffect(() => { load(); }, []);

  const buy = async (id, currency) => {
    if (busy) return; setBusy(true);
    try { const d = await spaceApi.skinsBuy(id, currency); setData(d); toast.success("Skin unlocked!"); }
    catch (e) { toast.error(e.message || "Purchase failed"); }
    finally { setBusy(false); }
  };
  const equip = async (id) => {
    if (busy) return; setBusy(true);
    try { const d = await spaceApi.skinsEquip(id); setData(d); toast.success("Skin equipped"); }
    catch (e) { toast.error(e.message || "Equip failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="ss-viewport" data-testid="space-supremacy-app">
      <div className="ss-atmosphere" /><div className="ss-grid" />
      <SpaceHomeBtn onClick={onBack} testid="skins-back" />
      <div className="wm-wrap" data-testid="skin-store">
        <p className="ss-eyebrow">Hero Cosmetics</p>
        <h1 className="wm-title"><Palette size={20} /> Skin Store</h1>
        {!data ? (
          <div className="bg-loading"><Loader2 size={26} className="bg-spin" /><span>Loading store…</span></div>
        ) : (
          <>
            <div className="sk-wallet">
              <span data-testid="skins-tokens"><Coins size={13} /> {data.tokens} tokens</span>
              <span data-testid="skins-credits"><Boxes size={13} /> {data.credits.toLocaleString()} T credits</span>
            </div>
            <div className="sk-grid">
              {data.catalog.map((c) => {
                const equipped = data.equipped?.[c.hero] === c.id;
                return (
                  <div className={`sk-card ${equipped ? "equipped" : ""}`} data-testid={`skin-${c.id}`} key={c.id}>
                    <span className="sk-swatch" style={{ background: c.color }} />
                    <span className="sk-name">{c.name}</span>
                    <span className="sk-hero">{c.hero.toUpperCase()}</span>
                    {c.owned ? (
                      <button className="sk-btn" disabled={busy || equipped} onClick={() => equip(c.id)} data-testid={`skin-equip-${c.id}`}>
                        {equipped ? <><Check size={12} /> Equipped</> : "Equip"}
                      </button>
                    ) : (
                      <div className="sk-buy">
                        <button className="sk-btn" disabled={busy} onClick={() => buy(c.id, "tokens")} data-testid={`skin-buy-tokens-${c.id}`}>{c.cost} tk</button>
                        <button className="sk-btn alt" disabled={busy} onClick={() => buy(c.id, "credits")} data-testid={`skin-buy-credits-${c.id}`}>{c.cost * 10} T</button>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
